// removed by extract-text-webpack-plugin
module.exports = {"overlay-container":"_1X3UtGgrMFqJjCDBfjM_5u","overlayContainer":"_1X3UtGgrMFqJjCDBfjM_5u","offline-text":"e18d5Mjkz5otSWuqeFJYA","offlineText":"e18d5Mjkz5otSWuqeFJYA","offline-button":"K3cMa6d8uAAEV4Si37Fwa","offlineButton":"K3cMa6d8uAAEV4Si37Fwa"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/offline/offlineOverlay.css
// module id = 538
// module chunks = 0